const getNbHitsPro = (facets = []) => {
    const itemPro =
        facets && facets.find(facet => facet.name === 'has_pro_conditions');
    return itemPro ? itemPro.data.true : 0;
};

export default getNbHitsPro;
